require('../../node_modules/bootstrap/dist/js/bootstrap');
